import {
DELETE_DOC_REQUEST,
 DELETE_DOC_SUCCESS , 
 DELETE_DOC_FAILURE , 
 DELETE_DOC_RESET 
} from "../actions/delete";

const initialState = {
  state: "idle",
};




export default function deleteDoc(state = initialState, action:any) {
  switch (action.type) {
    case DELETE_DOC_REQUEST:
      return {
        ...state,
        state: "loading",
      };
    case DELETE_DOC_SUCCESS: {
      return {
        ...state,
        ...action.payload,
        state: "success",
      };
    }
    case DELETE_DOC_FAILURE :
      return {
        ...state,
        ...action.payload,
        state: "failure",
      };
    case  DELETE_DOC_RESET:
      return {
        ...state,
        state: "idle",
      };

    default:
      return state;
  }
}
